import { ArrowRightIcon } from "@heroicons/react/24/outline";
import React, { PropsWithChildren } from "react";
import { Button } from "component-library";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const NextButtonContent: React.FC<{ text?: string }> = ({ text }) => {
  const { t } = useTranslation();
  return (
    <>
      {text ?? t("common.next")} <ArrowRightIcon width={15} />
    </>
  );
};

type FormWrapperProps = {
  onSubmit: () => void;
  SubmitButtonContent?: React.FC;
  isLoading?: boolean;
};

export const FormWrapper: React.FC<PropsWithChildren<FormWrapperProps>> = ({
  children,
  onSubmit,
  isLoading = false,
  SubmitButtonContent = NextButtonContent,
}) => {
  return (
    <form
      className="pt-10 pb-0"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      {children}
      <Button
        type="button"
        isLoading={isLoading}
        className={classNames("w-full mt-8")}
        variant="contained"
        onClick={onSubmit}
      >
        <SubmitButtonContent />
      </Button>
    </form>
  );
};
